export const state = () => ({
  entityInfo: {},
  matchRow: {},
  msgList: [],//历史消息
  objectJson:{},
  isQuickReply:false,
  changePersonChat:true,
  isMatchChatEntrance:false,
});
export const mutations = {
  set_entityInfo(state, v) {
    state.entityInfo = v;
  },
  set_matchRow(state, v) {
    state.matchRow = v;
  },
  set_msgList(state, v) {
    state.msgList = v;
  },
  set_isQuickReply(state, v) {
    state.isQuickReply = v;
  },
  set_objectJson(state, v) {
    state.objectJson = v;
  },
  change_person_chat(state, v) {//当前在操作切换联系人动作
    state.changePersonChat = v;
  },
  is_match_chat_entrance(state, v) {//是否匹配项议价入口
    state.isMatchChatEntrance = v;
  },
  
};
export default {
  state,
  mutations,
}
